import { StaticQuery, graphql } from "gatsby"
import React, { ReactNode } from "react"

import Typography from "@material-ui/core/Typography"

const query = graphql`
  query Copyright {
    site {
      siteMetadata {
        copyright
      }
    }
  }
`

const Copyright: React.FC<{}> = () => (
  <StaticQuery
    query={query}
    render={({
      site: {
        siteMetadata: { copyright },
      },
    }): ReactNode => (
      <Typography variant="body2" color="textSecondary" align="center">
        {copyright}
      </Typography>
    )}
  />
)

export default Copyright
